import {Audit} from '../audit-form/audit';
import {AuditForm} from '../api/models/audit-form';
import {Ward} from '../api/models/ward';

export class AuditContainer {
  constructor(public audit: Audit, public auditForm: AuditForm, public ward: Ward | null, public objectLabel: string | null) {
  }
}
